import { Component, inject } from '@angular/core';
import {UserService} from '@app/shared/_services/user.service';
import { TranslatePipe } from '../../_pipes/translate.pipe';

@Component({
    selector: 'app-signin-footer',
    templateUrl: './app-signin-footer.component.html',
    styleUrls: ['./app-signin-footer.component.scss'],
    imports: [TranslatePipe]
})
export class AppSigninFooterComponent {
  private _userService = inject(UserService);


  isSubaccount: boolean;
  customFooter?: string;
  currentYear = new Date().getFullYear(); // 2020
  constructor() {
    this.isSubaccount = this._userService.getInfoValue('is_subaccount') as boolean;
    this.customFooter  = this.isSubaccount && this._userService.getInfoValue('subaccount_config.footer') as string
  }

}
